import { disableShowMsg, enableShowMsg } from '@/mixins/ui-mixin';
import axios from 'axios';

export const ipDataBaseUrl = 'https://api.ipdata.co';
const ipDataApiKey = 'f5d37fcfca781039cdbba20acf0bc6593944c81991d38ee07d29e90b';

export class ClientLocation {
  ip: string = '';
  countryCode: string = '';
  countryName: string = '';
}

export const externalService = {
  getClientLocation
};

async function getClientLocation(): Promise<ClientLocation | null> {
  disableShowMsg();
  try {
    let response = await axios.get(`${ipDataBaseUrl}?api-key=${ipDataApiKey}&fields=ip,country_code,country_name`);
    let clientLocation = new ClientLocation();

    if (response && response.data && response.data.ip) {
      clientLocation.ip = response.data.ip;
      clientLocation.countryCode = response.data.country_code;
      clientLocation.countryName = response.data.country_name;
    }
    return clientLocation;
  } catch {
    return null;
  } finally {
    enableShowMsg();
  }
}
